import React from 'react';
import { IBaseInputElement } from './InputValidator';
import { SelectOptionsType } from '../Select';
export interface ErrorValidator<T> {
  /**
   * returns true if the input value is valid.
   */
  validate: (input: T) => boolean;
  getMessage: (fieldName?: string) => string;
}

export abstract class CommonInputValidators {
  public static getRequiredStringFieldValidator(): ErrorValidator<string> {
    return {
      validate: value => value && value.length > 0,
      getMessage: fieldName =>
        fieldName ? `The ${fieldName.toLowerCase()} field is required.` : 'This field is required.',
    };
  }

  public static getRequiredBooleanFieldValidator(): ErrorValidator<boolean> {
    return {
      validate: value => value === true,
      getMessage: fieldName =>
        fieldName ? `The ${fieldName.toLowerCase()} field is required.` : 'This field is required.',
    };
  }

  public static getMinLengthStringField(minLength: number): ErrorValidator<string> {
    return {
      validate: value => value && value.length >= minLength,
      getMessage: fieldName =>
        fieldName
          ? `The ${fieldName.toLowerCase()} field requires ${minLength} characters minimum.`
          : `${minLength} characters minimum.`,
    };
  }

  public static getExternalValueMatchStringField(
    externalValue: string,
    externalRef?: React.MutableRefObject<IBaseInputElement>
  ): ErrorValidator<string> {
    return {
      validate: value => externalValue?.localeCompare(value) === 0 && externalRef?.current?.isBlurred(),
      getMessage: fieldName => (fieldName ? `The ${fieldName.toLowerCase()}s do not match.` : `Fields do not match.`),
    };
  }

  public static getRequiredSelectFieldValidator<T = string>(): ErrorValidator<SelectOptionsType<T>> {
    return {
      validate: value => value && value.value !== null && value.value !== undefined,
      getMessage: fieldName =>
        fieldName ? `The ${fieldName.toLowerCase()} field is required.` : 'This field is required.',
    };
  }

  public static getValidEmailAddressFieldValidator(): ErrorValidator<string> {
    return {
      validate: value => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).trim().toLowerCase());
      },
      getMessage: () => 'This is not a valid e-mail address.',
    };
  }
}
